import { render, staticRenderFns } from "./HomeChooseUs.vue?vue&type=template&id=9ef4bc4c"
import script from "./HomeChooseUs.vue?vue&type=script&lang=js"
export * from "./HomeChooseUs.vue?vue&type=script&lang=js"
import style0 from "./HomeChooseUs.vue?vue&type=style&index=0&id=9ef4bc4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports